import Form from 'antd/lib/form';
import { useForm } from 'antd/lib/form/Form';
import Input from 'antd/lib/input';
import Modal from 'antd/lib/modal';
import * as React from 'react';
import { UserOutlined } from '@ant-design/icons';
import Text from 'antd/lib/typography/Text';
import * as API from '../../api';
import { globalMessage } from '../../utils/globalMessage';

export interface ForgotPasswordRequest {
    email: string;
}

interface ForgotPasswordModalProps {
    open: boolean;
    email?: string;
    onClose: () => void;
    onSuccess: () => void;
}

const ForgotPasswordModal: React.FC<ForgotPasswordModalProps> = (props: ForgotPasswordModalProps) => {
    const [form] = useForm();
    const [sendForgotPasswordIsLoading, setSendForgotPasswordIsLoading] = React.useState(false);

    const onSubmit = (values) => {
        const forgotPasswordRequest: ForgotPasswordRequest = {
            email: values.email,
        };

        setSendForgotPasswordIsLoading(true);

        API.forgotPassword(forgotPasswordRequest)
            .then(() => {
                globalMessage.success('Email sent! Check your inbox to reset your password.');
                props.onSuccess();
            })
            .catch((e) => {
                globalMessage.error(e.message);
            })
            .finally(() => {
                setSendForgotPasswordIsLoading(false);
            });
    };

    return (
        <Modal
            title="Reset your password"
            open={props.open}
            okButtonProps={{ loading: sendForgotPasswordIsLoading }}
            okText="Reset password"
            onOk={() => form.submit()}
            onCancel={props.onClose}
        >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Text type="secondary">Enter your email to receive a reset password link.</Text>
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={onSubmit}
                    style={{ marginTop: 24, width: 280 }}
                    initialValues={{ email: props.email ?? null }}
                >
                    <Form.Item name="email" rules={[{ required: true, message: 'Please enter your email' }]}>
                        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Email" />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default ForgotPasswordModal;
